import { useQuery } from '@tanstack/react-query';
import { ResumeTrackerService } from '../ResumeTrackerService';

export const useResumeTrackerDashboard = (
  dateFrom,
  dateTo,
  page = 1,
  pageSize = 10
) =>
  useQuery({
    queryKey: ['resume-tracker', 'dashboard', dateFrom, dateTo, page, pageSize],
    queryFn: () =>
      ResumeTrackerService.getDashboard(dateFrom, dateTo, page, pageSize),
    enabled: !!dateFrom && !!dateTo,
  });

export const useResumeTrackerJobCandidates = (
  jobRef,
  { dateFrom, dateTo, status, page = 1, pageSize = 10 }
) =>
  useQuery({
    queryKey: [
      'resume-tracker',
      'job',
      jobRef,
      dateFrom,
      dateTo,
      status,
      page,
      pageSize,
    ],
    queryFn: () =>
      ResumeTrackerService.getJobCandidates(jobRef, {
        dateFrom,
        dateTo,
        status,
        page,
        pageSize,
      }),
    enabled: !!jobRef && !!dateFrom && !!dateTo && !!status,
  });
